webpackJsonp([263791100135453],{

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(162);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDisplayName = function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function lazyload(WrappedComponent) {
	    return function (_Component) {
	      _inherits(LazyLoadDecorated, _Component);
	
	      function LazyLoadDecorated() {
	        _classCallCheck(this, LazyLoadDecorated);
	
	        var _this = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));
	
	        _this.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
	        return _this;
	      }
	
	      _createClass(LazyLoadDecorated, [{
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(
	            _index2.default,
	            options,
	            _react2.default.createElement(WrappedComponent, this.props)
	          );
	        }
	      }]);
	
	      return LazyLoadDecorated;
	    }(_react.Component);
	  };
	};

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forceCheck = exports.lazyload = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(27);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _event = __webpack_require__(347);
	
	var _scrollParent = __webpack_require__(348);
	
	var _scrollParent2 = _interopRequireDefault(_scrollParent);
	
	var _debounce = __webpack_require__(346);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _throttle = __webpack_require__(349);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _decorator = __webpack_require__(345);
	
	var _decorator2 = _interopRequireDefault(_decorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
	var LISTEN_FLAG = 'data-lazyload-listened';
	var listeners = [];
	var pending = [];
	
	// try to handle passive events
	var passiveEventSupported = false;
	try {
	  var opts = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passiveEventSupported = true;
	    }
	  });
	  window.addEventListener('test', null, opts);
	} catch (e) {}
	// if they are supported, setup the optional params
	// IMPORTANT: FALSE doubles as the default CAPTURE value!
	var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;
	
	/**
	 * Check if `component` is visible in overflow container `parent`
	 * @param  {node} component React component
	 * @param  {node} parent    component's scroll parent
	 * @return {bool}
	 */
	var checkOverflowVisible = function checkOverflowVisible(component, parent) {
	  var node = _reactDom2.default.findDOMNode(component);
	
	  var parentTop = void 0;
	  var parentHeight = void 0;
	
	  try {
	    var _parent$getBoundingCl = parent.getBoundingClientRect();
	
	    parentTop = _parent$getBoundingCl.top;
	    parentHeight = _parent$getBoundingCl.height;
	  } catch (e) {
	    parentTop = defaultBoundingClientRect.top;
	    parentHeight = defaultBoundingClientRect.height;
	  }
	
	  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
	
	  // calculate top and height of the intersection of the element's scrollParent and viewport
	  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
	  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
	
	  // check whether the element is visible in the intersection
	  var top = void 0;
	  var height = void 0;
	
	  try {
	    var _node$getBoundingClie = node.getBoundingClientRect();
	
	    top = _node$getBoundingClie.top;
	    height = _node$getBoundingClie.height;
	  } catch (e) {
	    top = defaultBoundingClientRect.top;
	    height = defaultBoundingClientRect.height;
	  }
	
	  var offsetTop = top - intersectionTop; // element's top relative to intersection
	
	  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API
	
	  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0;
	};
	
	/**
	 * Check if `component` is visible in document
	 * @param  {node} component React component
	 * @return {bool}
	 */
	var checkNormalVisible = function checkNormalVisible(component) {
	  var node = _reactDom2.default.findDOMNode(component);
	
	  // If this element is hidden by css rules somehow, it's definitely invisible
	  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;
	
	  var top = void 0;
	  var elementHeight = void 0;
	
	  try {
	    var _node$getBoundingClie2 = node.getBoundingClientRect();
	
	    top = _node$getBoundingClie2.top;
	    elementHeight = _node$getBoundingClie2.height;
	  } catch (e) {
	    top = defaultBoundingClientRect.top;
	    elementHeight = defaultBoundingClientRect.height;
	  }
	
	  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
	
	  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API
	
	  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
	};
	
	/**
	 * Detect if element is visible in viewport, if so, set `visible` state to true.
	 * If `once` prop is provided true, remove component as listener after checkVisible
	 *
	 * @param  {React} component   React component that respond to scroll and resize
	 */
	var checkVisible = function checkVisible(component) {
	  var node = _reactDom2.default.findDOMNode(component);
	  if (!node) {
	    return;
	  }
	
	  var parent = (0, _scrollParent2.default)(node);
	  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
	  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
	  if (visible) {
	    // Avoid extra render if previously is visible
	    if (!component.visible) {
	      if (component.props.once) {
	        pending.push(component);
	      }
	
	      component.visible = true;
	      component.forceUpdate();
	    }
	  } else if (!(component.props.once && component.visible)) {
	    component.visible = false;
	    if (component.props.unmountIfInvisible) {
	      component.forceUpdate();
	    }
	  }
	};
	
	var purgePending = function purgePending() {
	  pending.forEach(function (component) {
	    var index = listeners.indexOf(component);
	    if (index !== -1) {
	      listeners.splice(index, 1);
	    }
	  });
	
	  pending = [];
	};
	
	var lazyLoadHandler = function lazyLoadHandler() {
	  for (var i = 0; i < listeners.length; ++i) {
	    var listener = listeners[i];
	    checkVisible(listener);
	  }
	  // Remove `once` component in listeners
	  purgePending();
	};
	
	// Depending on component's props
	var delayType = void 0;
	var finalLazyLoadHandler = null;
	
	var LazyLoad = function (_Component) {
	  _inherits(LazyLoad, _Component);
	
	  function LazyLoad(props) {
	    _classCallCheck(this, LazyLoad);
	
	    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));
	
	    _this.visible = false;
	    return _this;
	  }
	
	  _createClass(LazyLoad, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (typeof process !== 'undefined' && ("production") !== 'production') {
	        if (_react2.default.Children.count(this.props.children) > 1) {
	          console.warn('[react-lazyload] Only one child is allowed to be passed to `LazyLoad`.');
	        }
	
	        if (this.props.wheel) {
	          // eslint-disable-line
	          console.warn('[react-lazyload] Props `wheel` is not supported anymore, try set `overflow` for lazy loading in overflow containers.');
	        }
	
	        // Warn the user if placeholder and height is not specified and the rendered height is 0
	        if (!this.props.placeholder && this.props.height === undefined && _reactDom2.default.findDOMNode(this).offsetHeight === 0) {
	          console.warn('[react-lazyload] Please add `height` props to <LazyLoad> for better performance.');
	        }
	      }
	
	      // It's unlikely to change delay type on the fly, this is mainly
	      // designed for tests
	      var needResetFinalLazyLoadHandler = false;
	      if (this.props.debounce !== undefined && delayType === 'throttle') {
	        console.warn('[react-lazyload] Previous delay function is `throttle`, now switching to `debounce`, try setting them unanimously');
	        needResetFinalLazyLoadHandler = true;
	      } else if (delayType === 'debounce' && this.props.debounce === undefined) {
	        console.warn('[react-lazyload] Previous delay function is `debounce`, now switching to `throttle`, try setting them unanimously');
	        needResetFinalLazyLoadHandler = true;
	      }
	
	      if (needResetFinalLazyLoadHandler) {
	        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        finalLazyLoadHandler = null;
	      }
	
	      if (!finalLazyLoadHandler) {
	        if (this.props.debounce !== undefined) {
	          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
	          delayType = 'debounce';
	        } else if (this.props.throttle !== undefined) {
	          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
	          delayType = 'throttle';
	        } else {
	          finalLazyLoadHandler = lazyLoadHandler;
	        }
	      }
	
	      if (this.props.overflow) {
	        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
	        if (parent && typeof parent.getAttribute === 'function') {
	          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
	          if (listenerCount === 1) {
	            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
	          }
	          parent.setAttribute(LISTEN_FLAG, listenerCount);
	        }
	      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
	        var _props = this.props,
	            scroll = _props.scroll,
	            resize = _props.resize;
	
	
	        if (scroll) {
	          (0, _event.on)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	        }
	
	        if (resize) {
	          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        }
	      }
	
	      listeners.push(this);
	      checkVisible(this);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return this.visible;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.overflow) {
	        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
	        if (parent && typeof parent.getAttribute === 'function') {
	          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
	          if (listenerCount === 0) {
	            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
	            parent.removeAttribute(LISTEN_FLAG);
	          } else {
	            parent.setAttribute(LISTEN_FLAG, listenerCount);
	          }
	        }
	      }
	
	      var index = listeners.indexOf(this);
	      if (index !== -1) {
	        listeners.splice(index, 1);
	      }
	
	      if (listeners.length === 0) {
	        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
	    }
	  }]);
	
	  return LazyLoad;
	}(_react.Component);
	
	LazyLoad.propTypes = {
	  once: _propTypes2.default.bool,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
	  overflow: _propTypes2.default.bool,
	  resize: _propTypes2.default.bool,
	  scroll: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	  placeholder: _propTypes2.default.node,
	  unmountIfInvisible: _propTypes2.default.bool
	};
	
	LazyLoad.defaultProps = {
	  once: false,
	  offset: 0,
	  overflow: false,
	  resize: false,
	  scroll: true,
	  unmountIfInvisible: false
	};
	
	var lazyload = exports.lazyload = _decorator2.default;
	exports.default = LazyLoad;
	exports.forceCheck = lazyLoadHandler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(85)))

/***/ }),

/***/ 346:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	function debounce(func, wait, immediate) {
	  var timeout = void 0;
	  var args = void 0;
	  var context = void 0;
	  var timestamp = void 0;
	  var result = void 0;
	
	  var later = function later() {
	    var last = +new Date() - timestamp;
	
	    if (last < wait && last >= 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      if (!immediate) {
	        result = func.apply(context, args);
	        if (!timeout) {
	          context = null;
	          args = null;
	        }
	      }
	    }
	  };
	
	  return function debounced() {
	    context = this;
	    args = arguments;
	    timestamp = +new Date();
	
	    var callNow = immediate && !timeout;
	    if (!timeout) {
	      timeout = setTimeout(later, wait);
	    }
	
	    if (callNow) {
	      result = func.apply(context, args);
	      context = null;
	      args = null;
	    }
	
	    return result;
	  };
	}

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.on = on;
	exports.off = off;
	function on(el, eventName, callback, opts) {
	  opts = opts || false;
	  if (el.addEventListener) {
	    el.addEventListener(eventName, callback, opts);
	  } else if (el.attachEvent) {
	    el.attachEvent("on" + eventName, function (e) {
	      callback.call(el, e || window.event);
	    });
	  }
	}
	
	function off(el, eventName, callback, opts) {
	  opts = opts || false;
	  if (el.removeEventListener) {
	    el.removeEventListener(eventName, callback, opts);
	  } else if (el.detachEvent) {
	    el.detachEvent("on" + eventName, callback);
	  }
	}

/***/ }),

/***/ 348:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * @fileOverview Find scroll parent
	 */
	
	exports.default = function (node) {
	  if (!node) {
	    return document.documentElement;
	  }
	
	  var excludeStaticParent = node.style.position === 'absolute';
	  var overflowRegex = /(scroll|auto)/;
	  var parent = node;
	
	  while (parent) {
	    if (!parent.parentNode) {
	      return node.ownerDocument || document.documentElement;
	    }
	
	    var style = window.getComputedStyle(parent);
	    var position = style.position;
	    var overflow = style.overflow;
	    var overflowX = style['overflow-x'];
	    var overflowY = style['overflow-y'];
	
	    if (position === 'static' && excludeStaticParent) {
	      parent = parent.parentNode;
	      continue;
	    }
	
	    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
	      return parent;
	    }
	
	    parent = parent.parentNode;
	  }
	
	  return node.ownerDocument || node.documentElement || document.documentElement;
	};

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = throttle;
	/*eslint-disable */
	function throttle(fn, threshhold, scope) {
	  threshhold || (threshhold = 250);
	  var last, deferTimer;
	  return function () {
	    var context = scope || this;
	
	    var now = +new Date(),
	        args = arguments;
	    if (last && now < last + threshhold) {
	      // hold on to it
	      clearTimeout(deferTimer);
	      deferTimer = setTimeout(function () {
	        last = now;
	        fn.apply(context, args);
	      }, threshhold);
	    } else {
	      last = now;
	      fn.apply(context, args);
	    }
	  };
	}

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Credits = function Credits() {
	  return _react2.default.createElement(
	    "span",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "credits-section flex-l items-start content-start justify-between mt5" },
	      _react2.default.createElement(
	        "div",
	        { className: "w-100 w-30-l pa5-l flex-l items-start content-start justify-end" },
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 dib section-title mb4 mb0-l" },
	          "Cast"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "w-100 w-70-l pa5-l" },
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 mb4" },
	          "Meka Butler as ",
	          _react2.default.createElement(
	            "i",
	            { className: "black-60" },
	            "Claire"
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 mb4" },
	          "S\xE9 Marie as ",
	          _react2.default.createElement(
	            "i",
	            { className: "black-60" },
	            "Monica"
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 mb4" },
	          "Linda Kanyarusoke as ",
	          _react2.default.createElement(
	            "i",
	            { className: "black-60" },
	            "Chris"
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 mb4" },
	          "Suzanne Sadler as ",
	          _react2.default.createElement(
	            "i",
	            { className: "black-60" },
	            "Susan"
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 mb4" },
	          "Russell Hawkins as ",
	          _react2.default.createElement(
	            "i",
	            { className: "black-60" },
	            "Ike"
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 mb4" },
	          "Dan McCurry as ",
	          _react2.default.createElement(
	            "i",
	            { className: "black-60" },
	            "Matthew"
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 mb4" },
	          "Matthew Wallenstein as ",
	          _react2.default.createElement(
	            "i",
	            { className: "black-60" },
	            "Michael"
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 mb4" },
	          "Sarah Brunner as ",
	          _react2.default.createElement(
	            "i",
	            { className: "black-60" },
	            "Tristan"
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 mb4" },
	          "Bruce Crocker as ",
	          _react2.default.createElement(
	            "i",
	            { className: "black-60" },
	            "Senator Wyatt"
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "credits-section flex-l items-start content-start justify-between mt5" },
	      _react2.default.createElement(
	        "div",
	        { className: "w-100 w-30-l pa5-l flex-l items-start content-start justify-end" },
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 dib section-title mb4 mb0-l" },
	          "Crew"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "w-100 w-70-l pa5-l" },
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 mb4" },
	          _react2.default.createElement(
	            "span",
	            { className: "label" },
	            "Written and Directed by"
	          ),
	          _react2.default.createElement("br", null),
	          "Erik Sutch"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 mb4" },
	          _react2.default.createElement(
	            "span",
	            { className: "label" },
	            "Executive Producer"
	          ),
	          _react2.default.createElement("br", null),
	          "Shawn Petersen"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 mb4" },
	          _react2.default.createElement(
	            "span",
	            { className: "label" },
	            "Producers"
	          ),
	          _react2.default.createElement("br", null),
	          "Jacob Z. Gross",
	          _react2.default.createElement("br", null),
	          "Erik Sutch"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 mb4" },
	          _react2.default.createElement(
	            "span",
	            { className: "label" },
	            "Director of Photography"
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "a",
	            { target: "_blank", href: "http://www.daniellecalodney.com/" },
	            "Danielle Calodney"
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 mb4" },
	          _react2.default.createElement(
	            "span",
	            { className: "label" },
	            "Composer"
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "a",
	            { target: "_blank", href: "https://vimeo.com/mattfletchernoisycreativ" },
	            "Matt Fletcher"
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 mb4" },
	          _react2.default.createElement(
	            "span",
	            { className: "label" },
	            "Additional Music"
	          ),
	          _react2.default.createElement("br", null),
	          "Julius Eastman \u201CFemenine\u201D",
	          _react2.default.createElement("br", null),
	          "Shin Joong Hyun \u201CI Don\u2019t Like\u201D",
	          _react2.default.createElement("br", null),
	          "Josef Leimberg \u201CSpirits of the Ancestors\u201D",
	          _react2.default.createElement("br", null),
	          "Mary Brulatour \u201CRabbit Mask\u201D",
	          _react2.default.createElement("br", null),
	          "Moses Sumney \u201CLonely World\u201D"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 mb4" },
	          _react2.default.createElement(
	            "span",
	            { className: "label" },
	            "Artwork"
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "a",
	            { target: "_blank", href: "http://www.izzyjarvis.com/" },
	            "Izzy Jarvis"
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "lh-copy black f3 mb4" },
	          _react2.default.createElement(
	            "span",
	            { className: "label" },
	            "Website"
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "a",
	            { target: "_blank", href: "https://keiyasui.com" },
	            "Kei Yasui"
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Credits;
	module.exports = exports["default"];

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(27);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Img = function (_React$Component) {
	  _inherits(Img, _React$Component);
	
	  function Img() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Img);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      shouldShow: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Img.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var imageObject = new Image();
	    imageObject.src = this.props.imageSrc;
	    imageObject.onload = function () {
	      _this2.setState({
	        shouldShow: true,
	        imageSrc: _this2.props.imageSrc
	      });
	    };
	  };
	
	  Img.prototype.render = function render() {
	    if (this.props.isBg) {
	      return _react2.default.createElement(
	        'div',
	        { className: "aspect-ratio aspect-ratio--img img-preload bg-center bg-no-repeat mb3" + (this.state.shouldShow ? ' is-loaded' : '') },
	        _react2.default.createElement('div', {
	          className: 'aspect-ratio--object cover',
	          style: {
	            backgroundImage: 'url(' + this.state.imageSrc + ')'
	          } })
	      );
	    } else {
	      return _react2.default.createElement('img', { className: "img-preload" + (this.state.shouldShow ? ' is-loaded' : '') + (' ' + this.props.className), src: this.state.imageSrc });
	    }
	  };
	
	  return Img;
	}(_react2.default.Component);
	
	exports.default = Img;
	module.exports = exports['default'];

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Synopsis = function Synopsis() {
	  return _react2.default.createElement(
	    "div",
	    { className: "flex-l items-start content-start justify-between mt5" },
	    _react2.default.createElement(
	      "div",
	      { className: "w-100 w-30-l pa5-l flex-l items-start content-start justify-end" },
	      _react2.default.createElement(
	        "p",
	        { className: "lh-copy black f3 dib section-title mb4 mb0-l" },
	        "Synopsis"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "w-100 w-70-l pa5-l" },
	      _react2.default.createElement(
	        "p",
	        { className: "lh-copy black f3" },
	        "Claire is an abortion doctor living in a post-industrial America where football no longer exists, but TRAP laws still do. After restrictive state regulations force Claire to shut down her clinic, she drives a taxi while waiting to reopen. The senator who was instrumental in passing the legislation dies in her backseat, and his wife and daughter come out of the woodwork and into Claire\u2019s life."
	      )
	    )
	  );
	};
	
	exports.default = Synopsis;
	module.exports = exports["default"];

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(44);
	
	var _graphql = __webpack_require__(50);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _reactHelmet = __webpack_require__(48);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Synopsis = __webpack_require__(184);
	
	var _Synopsis2 = _interopRequireDefault(_Synopsis);
	
	var _Credits = __webpack_require__(182);
	
	var _Credits2 = _interopRequireDefault(_Credits);
	
	var _reactLazyload = __webpack_require__(162);
	
	var _reactLazyload2 = _interopRequireDefault(_reactLazyload);
	
	var _Img = __webpack_require__(183);
	
	var _Img2 = _interopRequireDefault(_Img);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutPage = function (_React$Component) {
	  _inherits(AboutPage, _React$Component);
	
	  function AboutPage() {
	    _classCallCheck(this, AboutPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  AboutPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'section',
	      { className: 'section mv5 pv5' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Careful Not to Cry | About'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'fluid-width center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'flex items-center content-center justify-center' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'lh-copy black f2 tc mt5 section-title dib center mb4' },
	            'About'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-l items-center content-center justify-between' },
	          _react2.default.createElement(
	            'div',
	            { className: 'w-100 w-50-l pa5-l mb4 mb0-l' },
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/img/main-poster.jpg') })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'w-100 w-50-l pa5-l flex-l items-center content-center justify-center' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'f2 lh-copy black' },
	              'Careful Not to Cry is the feature debut of director Erik Sutch.'
	            )
	          )
	        ),
	        _react2.default.createElement(_Synopsis2.default, null),
	        _react2.default.createElement(_Credits2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-l items-start content-start justify-between mt5' },
	          _react2.default.createElement(
	            'div',
	            { className: 'w-100 w-30-l pa5-l flex-l items-start content-start justify-end' },
	            _react2.default.createElement(
	              'p',
	              { className: 'lh-copy black f3 dib section-title mb4 mb0-l' },
	              'Posters'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'w-100 w-70-l pa5-l flex items-start content-start justify-between' },
	            _react2.default.createElement(
	              _reactLazyload2.default,
	              { height: 450, once: true, offset: 100 },
	              _react2.default.createElement(
	                'a',
	                { className: 'db image-column', target: '_blank', href: (0, _gatsbyLink.withPrefix)('/img/poster-1.jpg') },
	                _react2.default.createElement(_Img2.default, { isBg: false, imageSrc: (0, _gatsbyLink.withPrefix)('/img/poster-1.jpg') })
	              )
	            ),
	            _react2.default.createElement(
	              _reactLazyload2.default,
	              { height: 450, once: true, offset: 100 },
	              _react2.default.createElement(
	                'a',
	                { className: 'db image-column', target: '_blank', href: (0, _gatsbyLink.withPrefix)('/img/poster-2.jpg') },
	                _react2.default.createElement(_Img2.default, { isBg: false, imageSrc: (0, _gatsbyLink.withPrefix)('/img/poster-2.jpg') })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-l items-start content-start justify-between mt5' },
	          _react2.default.createElement(
	            'div',
	            { className: 'w-100 w-30-l pa5-l flex-l items-start content-start justify-end' },
	            _react2.default.createElement(
	              'p',
	              { className: 'lh-copy black f3 dib section-title mb4 mb0-l' },
	              'Trailer'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'w-100 w-70-l pa5-l' },
	            _react2.default.createElement(
	              'div',
	              { className: 'aspect-ratio aspect-ratio--16x9 relative w-100' },
	              _react2.default.createElement('iframe', { className: 'aspect-ratio--object', src: 'https://www.youtube.com/embed/f8hbWs2tm8I', frameBorder: '0', allow: 'autoplay; encrypted-media', allowFullScreen: true })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return AboutPage;
	}(_react2.default.Component);
	
	exports.default = AboutPage;
	;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-10db3747a9feb26e5d1d.js